let state = function (){
    return {
        showModal:false,
    }
}

const getters = {
    displayModal(state){
        return state.showModal
    }
}

const mutations = {
    toggleModal(state){
        state.showModal = !state.showModal
    },
    turnModalOn(state){
        state.showModal = true
    },
    turnModalOff(state){
        state.showModal = false
    },
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/modal.js